import { type TagVariant } from '@volvo/vcdk';
import React from 'react';

type Props = {
  variant: TagVariant;
  className?: string;
};

const Dot: React.FC<Props> = ({ variant, className }) => {
  const getBackgroundColor = (variant: TagVariant) => {
    switch (variant) {
      case 'info':
      case 'info-subtle':
        return 'bg-info';
      case 'warning':
      case 'warning-subtle':
        return 'bg-warning';
      case 'error':
      case 'error-subtle':
        return 'bg-error';
      case 'success':
      case 'success-subtle':
        return 'bg-success';
      case 'neutral':
      case 'neutral-subtle':
        return 'bg-gray-dark';
      default:
        return 'bg-gray-dark';
    }
  };

  return <span className={`${getBackgroundColor(variant)} inline-block size-6 rounded-full ${className ?? ''}`}></span>;
};

export default Dot;
